module.exports = __webpack_public_path__ + "img/full4-min.986234c2.png";